import { useEffect, useState } from 'react';
import type { Brand } from '../../types/codexOrder';

function TopBar({
  logo,
  brand,
  bizName,
  loading,
}: {
  loading: boolean;
  brand: Brand | undefined;
  bizName: string | undefined;
  logo: string | null | undefined;
}) {
  const [showName, setShowName] = useState(false);

  function detectSquareImage(base64Img: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const { width, height } = img;
        resolve(width === height);
      };
      img.onerror = reject;
      img.src = base64Img;
    });
  }

  useEffect(() => {
    if (logo) {
      detectSquareImage(logo)
        .then(isSquare => {
          if (isSquare) setShowName(true);
        })
        .catch(() => {
          setShowName(false);
        });
    }
  }, [logo]);

  return (
    <div className="bg-white flex items-center gap-x-3 py-3 px-4 border-b border-up-black-20 md:rounded-b-lg md:mx-2 min-h-16">
      {loading ? (
        <div className="h-10 w-1/2 max-w-50 rounded-lg shimmer" />
      ) : (
        <>
          {logo && <img src={logo} alt={bizName ?? 'logo'} className="h-10" />}
          {(showName || !logo) && (
            <p className="font-bold">{brand?.name ?? bizName ?? ''}</p>
          )}
        </>
      )}
    </div>
  );
}

export default TopBar;
